/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ product: NonNullable<unknown> }} Soft_Round_Moose_PullInputs */

const en_soft_round_moose_pull = /** @type {(inputs: Soft_Round_Moose_PullInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Link my purchase now`);
	return /** @type {LocalizedString} */ (`Link my subscription now`)
	
};

const id_soft_round_moose_pull = /** @type {(inputs: Soft_Round_Moose_PullInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Tautkan pembelian saya sekarang`);
	return /** @type {LocalizedString} */ (`Hubungkan langganan saya sekarang`)
	
};

const ms_soft_round_moose_pull = /** @type {(inputs: Soft_Round_Moose_PullInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Pautkan pembelian saya sekarang`);
	return /** @type {LocalizedString} */ (`Pautkan langganan saya sekarang`)
	
};

const ca_soft_round_moose_pull = /** @type {(inputs: Soft_Round_Moose_PullInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Vincula la meva compra ara`);
	return /** @type {LocalizedString} */ (`Enllaçar la meva subscripció`)
	
};

const cs_soft_round_moose_pull = /** @type {(inputs: Soft_Round_Moose_PullInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Propojit můj nákup nyní`);
	return /** @type {LocalizedString} */ (`Propojit mé předplatné`)
	
};

const da_soft_round_moose_pull = /** @type {(inputs: Soft_Round_Moose_PullInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Tilknyt mit køb nu`);
	return /** @type {LocalizedString} */ (`Forbind mit abonnement nu`)
	
};

const de_soft_round_moose_pull = /** @type {(inputs: Soft_Round_Moose_PullInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Meinen Kauf jetzt verknüpfen`);
	return /** @type {LocalizedString} */ (`Mein Abonnement jetzt verknüpfen`)
	
};

const et_soft_round_moose_pull = /** @type {(inputs: Soft_Round_Moose_PullInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Seo minu ost kohe`);
	return /** @type {LocalizedString} */ (`Seo minu tellimus kohe`)
	
};

const es_soft_round_moose_pull = /** @type {(inputs: Soft_Round_Moose_PullInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Vincular mi compra ahora`);
	return /** @type {LocalizedString} */ (`Vincular mi suscripción`)
	
};

const fr_soft_round_moose_pull = /** @type {(inputs: Soft_Round_Moose_PullInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Lier mon achat maintenant`);
	return /** @type {LocalizedString} */ (`Lier mon abonnement`)
	
};

const hr_soft_round_moose_pull = /** @type {(inputs: Soft_Round_Moose_PullInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Poveži moju kupnju sada`);
	return /** @type {LocalizedString} */ (`Poveži moju pretplatu`)
	
};

const it_soft_round_moose_pull = /** @type {(inputs: Soft_Round_Moose_PullInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Collega il mio acquisto ora`);
	return /** @type {LocalizedString} */ (`Collega il mio abbonamento ora`)
	
};

const lv_soft_round_moose_pull = /** @type {(inputs: Soft_Round_Moose_PullInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Saistīt manu pirkumu tagad`);
	return /** @type {LocalizedString} */ (`Piesaistīt manu abonementu`)
	
};

const lt_soft_round_moose_pull = /** @type {(inputs: Soft_Round_Moose_PullInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Susieti mano pirkinį dabar`);
	return /** @type {LocalizedString} */ (`Susieti mano prenumeratą`)
	
};

const hu_soft_round_moose_pull = /** @type {(inputs: Soft_Round_Moose_PullInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Vásárlásom összekapcsolása most`);
	return /** @type {LocalizedString} */ (`Az előfizetés összekapcsolása most`)
	
};

const nl_soft_round_moose_pull = /** @type {(inputs: Soft_Round_Moose_PullInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Mijn aankoop nu koppelen`);
	return /** @type {LocalizedString} */ (`Mijn abonnement nu koppelen`)
	
};

const nb_soft_round_moose_pull = /** @type {(inputs: Soft_Round_Moose_PullInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Knytt mitt kjøp nå`);
	return /** @type {LocalizedString} */ (`Koble til abonnementet nå`)
	
};

const pl_soft_round_moose_pull = /** @type {(inputs: Soft_Round_Moose_PullInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Powiąż mój zakup teraz`);
	return /** @type {LocalizedString} */ (`Powiąż moją subskrypcję`)
	
};

const pt_soft_round_moose_pull = /** @type {(inputs: Soft_Round_Moose_PullInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Vincular minha compra agora`);
	return /** @type {LocalizedString} */ (`Vincular minha assinatura agora`)
	
};

const ro_soft_round_moose_pull = /** @type {(inputs: Soft_Round_Moose_PullInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Asociază achiziția mea acum`);
	return /** @type {LocalizedString} */ (`Conectează-mi abonamentul acum`)
	
};

const sk_soft_round_moose_pull = /** @type {(inputs: Soft_Round_Moose_PullInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Prepojiť môj nákup teraz`);
	return /** @type {LocalizedString} */ (`Prepojiť moje predplatné`)
	
};

const sl_soft_round_moose_pull = /** @type {(inputs: Soft_Round_Moose_PullInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Poveži moj nakup zdaj`);
	return /** @type {LocalizedString} */ (`Poveži mojo naročnino zdaj`)
	
};

const fi_soft_round_moose_pull = /** @type {(inputs: Soft_Round_Moose_PullInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Linkitä ostokseni nyt`);
	return /** @type {LocalizedString} */ (`Yhdistä tilaukseni nyt`)
	
};

const sv_soft_round_moose_pull = /** @type {(inputs: Soft_Round_Moose_PullInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Koppla mitt köp nu`);
	return /** @type {LocalizedString} */ (`Länka min prenumeration nu`)
	
};

const vi_soft_round_moose_pull = /** @type {(inputs: Soft_Round_Moose_PullInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Liên kết mua hàng của tôi ngay bây giờ`);
	return /** @type {LocalizedString} */ (`Kết nối gói đăng ký của tôi ngay`)
	
};

const tr_soft_round_moose_pull = /** @type {(inputs: Soft_Round_Moose_PullInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Satın almamı şimdi bağla`);
	return /** @type {LocalizedString} */ (`Aboneliğimi şimdi bağla`)
	
};

const el_soft_round_moose_pull = /** @type {(inputs: Soft_Round_Moose_PullInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Σύνδεση της αγοράς μου τώρα`);
	return /** @type {LocalizedString} */ (`Σύνδεση της συνδρομής μου τώρα`)
	
};

const bg_soft_round_moose_pull = /** @type {(inputs: Soft_Round_Moose_PullInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Свържи покупката ми сега`);
	return /** @type {LocalizedString} */ (`Свързване на моя абонамент сега`)
	
};

const ru_soft_round_moose_pull = /** @type {(inputs: Soft_Round_Moose_PullInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Привязать мою покупку`);
	return /** @type {LocalizedString} */ (`Привязать мою подписку`)
	
};

const sr_soft_round_moose_pull = /** @type {(inputs: Soft_Round_Moose_PullInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Повежи моју куповину сада`);
	return /** @type {LocalizedString} */ (`Повежи моју претплату`)
	
};

const uk_soft_round_moose_pull = /** @type {(inputs: Soft_Round_Moose_PullInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Прив'язати мою покупку зараз`);
	return /** @type {LocalizedString} */ (`Приєднайте мою підписку зараз`)
	
};

const ka_soft_round_moose_pull = /** @type {(inputs: Soft_Round_Moose_PullInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`დააკავშირე ჩემი შეძენა ახლავე`);
	return /** @type {LocalizedString} */ (`დააკავშირე ჩემი გამოწერა ახლავე`)
	
};

const hi_soft_round_moose_pull = /** @type {(inputs: Soft_Round_Moose_PullInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`अभी मेरी खरीद लिंक करें`);
	return /** @type {LocalizedString} */ (`मेरा सब्सक्रिप्शन अभी लिंक करें`)
	
};

const th_soft_round_moose_pull = /** @type {(inputs: Soft_Round_Moose_PullInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`เชื่อมโยงการซื้อของฉันตอนนี้`);
	return /** @type {LocalizedString} */ (`เชื่อมต่อการเป็นสมาชิกของฉันตอนนี้`)
	
};

const ko_soft_round_moose_pull = /** @type {(inputs: Soft_Round_Moose_PullInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`지금 내 구매 연결하기`);
	return /** @type {LocalizedString} */ (`지금 내 구독 연결하기`)
	
};

const zh_soft_round_moose_pull = /** @type {(inputs: Soft_Round_Moose_PullInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`立即链接我的订阅`)
};

const zh_tw_soft_round_moose_pull = /** @type {(inputs: Soft_Round_Moose_PullInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`立即連結我的購買`);
	return /** @type {LocalizedString} */ (`立即連結我的訂閱`)
	
};

const ja_soft_round_moose_pull = /** @type {(inputs: Soft_Round_Moose_PullInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`今すぐ購入をリンクする`);
	return /** @type {LocalizedString} */ (`今すぐサブスクリプションをリンクする`)
	
};

/**
* | product | output |
* | --- | --- |
* | "origin" | "Link my purchase now" |
* | * | "Link my subscription now" |
*
* @param {Soft_Round_Moose_PullInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const soft_round_moose_pull = /** @type {((inputs: Soft_Round_Moose_PullInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Soft_Round_Moose_PullInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_soft_round_moose_pull(inputs)
	if (locale === "ms") return ms_soft_round_moose_pull(inputs)
	if (locale === "ca") return ca_soft_round_moose_pull(inputs)
	if (locale === "cs") return cs_soft_round_moose_pull(inputs)
	if (locale === "da") return da_soft_round_moose_pull(inputs)
	if (locale === "de") return de_soft_round_moose_pull(inputs)
	if (locale === "et") return et_soft_round_moose_pull(inputs)
	if (locale === "es") return es_soft_round_moose_pull(inputs)
	if (locale === "fr") return fr_soft_round_moose_pull(inputs)
	if (locale === "hr") return hr_soft_round_moose_pull(inputs)
	if (locale === "it") return it_soft_round_moose_pull(inputs)
	if (locale === "lv") return lv_soft_round_moose_pull(inputs)
	if (locale === "lt") return lt_soft_round_moose_pull(inputs)
	if (locale === "hu") return hu_soft_round_moose_pull(inputs)
	if (locale === "nl") return nl_soft_round_moose_pull(inputs)
	if (locale === "nb") return nb_soft_round_moose_pull(inputs)
	if (locale === "pl") return pl_soft_round_moose_pull(inputs)
	if (locale === "pt") return pt_soft_round_moose_pull(inputs)
	if (locale === "ro") return ro_soft_round_moose_pull(inputs)
	if (locale === "sk") return sk_soft_round_moose_pull(inputs)
	if (locale === "sl") return sl_soft_round_moose_pull(inputs)
	if (locale === "fi") return fi_soft_round_moose_pull(inputs)
	if (locale === "sv") return sv_soft_round_moose_pull(inputs)
	if (locale === "vi") return vi_soft_round_moose_pull(inputs)
	if (locale === "tr") return tr_soft_round_moose_pull(inputs)
	if (locale === "el") return el_soft_round_moose_pull(inputs)
	if (locale === "bg") return bg_soft_round_moose_pull(inputs)
	if (locale === "ru") return ru_soft_round_moose_pull(inputs)
	if (locale === "sr") return sr_soft_round_moose_pull(inputs)
	if (locale === "uk") return uk_soft_round_moose_pull(inputs)
	if (locale === "ka") return ka_soft_round_moose_pull(inputs)
	if (locale === "hi") return hi_soft_round_moose_pull(inputs)
	if (locale === "th") return th_soft_round_moose_pull(inputs)
	if (locale === "ko") return ko_soft_round_moose_pull(inputs)
	if (locale === "zh") return zh_soft_round_moose_pull(inputs)
	if (locale === "zh-tw") return zh_tw_soft_round_moose_pull(inputs)
	if (locale === "ja") return ja_soft_round_moose_pull(inputs)
	return en_soft_round_moose_pull(inputs)
});